import { Controller } from "@hotwired/stimulus"
import { landPoints } from "../passport_map/land"
import { flatView, drawLand, routePoints, stroke } from "../passport_map/world"

const FONT = "ui-rounded, 'SF Pro Rounded', ui-sans-serif, system-ui, sans-serif"
const LABELS = 10

// A still world map with routes between events, drawn wider the more passports took them.
// Routes are [from, to, passports, colour], with from and to indexes into events.
export default class extends Controller {
  static targets = [ "land", "routes" ]
  static values = { events: Array, routes: Array }

  connect() {
    this.events = this.eventsValue
    this.routes = this.routesValue
    this.landPoints = landPoints()
    this.resizeObserver = new ResizeObserver(() => this.draw())
    this.resizeObserver.observe(this.element)
  }

  disconnect() {
    this.resizeObserver.disconnect()
  }

  draw() {
    const width = this.element.clientWidth
    const height = this.element.clientHeight
    const dpr = window.devicePixelRatio || 1
    for (const canvas of [ this.landTarget, this.routesTarget ]) {
      canvas.width = Math.round(width * dpr)
      canvas.height = Math.round(height * dpr)
      canvas.getContext("2d").setTransform(dpr, 0, 0, dpr, 0, 0)
    }

    const weight = new Map()
    this.routes.forEach(([ from, to, count ]) => {
      weight.set(from, (weight.get(from) || 0) + count)
      weight.set(to, (weight.get(to) || 0) + count)
    })
    const total = [ ...weight.values() ].reduce((sum, value) => sum + value, 0) || 1
    const centerLongitude = [ ...weight ].reduce((sum, [ index, value ]) => sum + this.events[index].lng * value, 0) / total
    const view = flatView(width, height, { padding: { top: 12, right: 12, bottom: 12, left: 12 }, centerLongitude })
    drawLand(this.landTarget.getContext("2d"), view, this.landPoints, width, height)

    const ctx = this.routesTarget.getContext("2d")
    const most = Math.max(1, ...this.routes.map(([ , , count ]) => count))
    ctx.lineCap = "round"
    ;[ ...this.routes ].sort((a, b) => a[2] - b[2]).forEach(([ from, to, count, color ]) => {
      const a = this.events[from]
      const b = this.events[to]
      ctx.strokeStyle = color
      ctx.globalAlpha = 0.75
      ctx.lineWidth = 1.2 + 5 * Math.sqrt(count / most)
      stroke(ctx, routePoints(view, [ a.lng, a.lat ], [ b.lng, b.lat ]))
    })
    ctx.globalAlpha = 1

    const placed = []
    ctx.font = `600 11px ${FONT}`
    ;[ ...weight ].sort((a, b) => b[1] - a[1]).forEach(([ index ], rank) => {
      const event = this.events[index]
      const [ x, y ] = view.project([ event.lng, event.lat ])
      ctx.fillStyle = "#e11d48"
      ctx.beginPath()
      ctx.arc(x, y, 3, 0, Math.PI * 2)
      ctx.fill()
      if (rank >= LABELS || placed.some((city) => city === event.city)) return
      placed.push(event.city)
      ctx.lineWidth = 3
      ctx.strokeStyle = "rgba(251, 246, 236, 0.9)"
      ctx.strokeText(event.city, x + 6, y + 4)
      ctx.fillStyle = "#44403c"
      ctx.fillText(event.city, x + 6, y + 4)
    })
  }
}
